import React from "react";
import {
  FaInstagram,
  FaFacebookF,
  FaLinkedinIn,
} from "react-icons/fa";

import poLogo from "../../assets/images/logo/po-logo.png";

const XIcon = () => <span className="x-social-icon">X</span>;

const SocialShare = [
  { Social: <FaFacebookF />, link: "https://www.facebook.com/paul.olle.3/" },
  { Social: <FaLinkedinIn />, link: "https://www.linkedin.com/in/paulolle/" },
  { Social: <FaInstagram />, link: "https://www.instagram.com/paulolle971/" },
  { Social: <XIcon />, link: "https://x.com/StyxisReal" },
];

const FooterSkills = [
  "React",
  "Next.js",
  "TypeScript",
  "Three.js",
  "D3.js",
  "Codex",
  "n8n",
  "Prisma",
  "Solidity",
  "Ethers.js",
];

const FooterTwo = () => {
  return (
    <footer className="footer-style-2 portfolio-footer">
      <div className="wrapper plr--50 plr_sm--20">
        <div className="row align-items-start">
          <div className="col-lg-4 col-md-12 col-12">
            <div className="footer-brand-card">
              <a className="footer-brand" href="/" aria-label="Paul Olle home">
                <img src={poLogo} alt="" />
                <span>
                  <strong>Paul Olle</strong>
                  <em>Software Engineer</em>
                </span>
              </a>
              <p>
                Building polished React, Next.js, AI workflow, Web3, and interactive 3D products from Lausanne.
              </p>
            </div>
          </div>
          <div className="col-lg-4 col-md-7 col-12 mt_md--30 mt_sm--30">
            <div className="footer-stack">
              <span className="footer-label">Core stack</span>
              <div className="footer-skill-cloud">
                {FooterSkills.map((skill) => (
                  <a href="#service" key={skill}>{skill}</a>
                ))}
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-5 col-12 mt_md--30 mt_sm--30">
            <div className="footer-actions">
              <ul className="social-share rn-lg-size d-flex justify-content-center liststyle">
                {SocialShare.map((val, i) => (
                  <li key={i}>
                    <a href={`${val.link}`} target="_blank" rel="noreferrer">{val.Social}</a>
                  </li>
                ))}
              </ul>
              <div className="text">
                <p>Copyright © 2026 Paul Olle. All Rights Reserved.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default FooterTwo;
